import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import CopilotIcon from "components/shared/CopilotIcon/CopilotIcon";

// Colours: the info icon is the portal's usual info blue; the Copilot badge is black with a white
// mark; the hover pill is GitHub's Gray 2 (brand.github.com/foundations/color).
const INFO_COLOR = "#0084ff";
const COPILOT_COLOR = "#101411";
const HOVER_BG = "#E4EBE6";

// The one icon that opens a user's details (profile + Copilot usage): the info
// icon, always the same and always clickable, with a small Copilot badge on its
// corner only when the user holds a Copilot license. Unlicensed users get the
// plain info icon. `licensedOrgNames` is the list of orgs they're licensed in
// ([] = not licensed); leave it undefined to show no badge at all (e.g. when
// the viewer can't see Copilot data).
const UserProfileButton = ({ onClick, licensedOrgNames, userLabel = "this user" }) => {
  const showCopilot = Array.isArray(licensedOrgNames);
  const licensed = showCopilot && licensedOrgNames.length > 0;

  const tooltip = !showCopilot
    ? `View ${userLabel}'s details`
    : licensed
      ? `View ${userLabel}'s details · Copilot licensed in ${licensedOrgNames.join(", ")}`
      : `View ${userLabel}'s details · No Copilot license`;
  const ariaLabel = !showCopilot ? "View user details" : licensed ? "View user details, Copilot licensed" : "View user details, no Copilot license";

  return (
    <Tooltip title={tooltip} arrow>
      <IconButton
        size="small"
        aria-label={ariaLabel}
        onClick={onClick}
        // A soft pill behind the icon on hover/keyboard focus, so it reads as a button.
        sx={{ p: 0.5, borderRadius: "14px", cursor: "pointer", position: "relative", overflow: "visible", "&:hover, &.Mui-focusVisible": { backgroundColor: HOVER_BG } }}
      >
        <InfoOutlinedIcon sx={{ color: INFO_COLOR, fontSize: 26 }} />
        {licensed && (
          <Box
            component="span"
            data-testid="copilot-badge"
            sx={{
              position: "absolute",
              right: -1,
              bottom: -1,
              width: 16,
              height: 16,
              borderRadius: "50%",
              backgroundColor: COPILOT_COLOR,
              border: "1.5px solid #fff",
              boxSizing: "border-box",
              display: "grid",
              placeItems: "center",
              color: "#fff",
            }}
          >
            <CopilotIcon sx={{ fontSize: 10, position: "relative", top: "0.5px" }} />
          </Box>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default UserProfileButton;
